/**
 * After the session moves to another workspace, open the Projects page with
 * no drilled-in project and no leftover filter bar.
 *
 * `window.location.reload()` would keep `?project=` and the home-page
 * filters in sessionStorage, so the new workspace would reopen the previous
 * workspace's project (often as "No matches for your filters").
 *
 * The storage key matches `FILTERS_STORAGE_KEY` in `useHomePage.js`.
 */
export const HOME_PAGE_FILTERS_STORAGE_KEY = 'homePageFilters';

export function goHomeAfterWorkspaceChange(navigate = (path) => window.location.assign(path)) {
    try {
        sessionStorage.removeItem(HOME_PAGE_FILTERS_STORAGE_KEY);
    } catch {
        // Storage can throw (private mode). Navigation still has to leave the old project.
    }
    navigate('/');
}
